import { ChevronLeft, ChevronRight } from "lucide-react";

// Lista de páginas com reticências: 1 … 4 5 6 … 12
const pageList = (page, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total, page, page - 1, page + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push('…' + p);
    out.push(p);
  });
  return out;
};

export const Pagination = ({ page, pageSize, total, onChange, noun = 'itens' }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const arrow = 'flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition hover:bg-gray-100 disabled:pointer-events-none disabled:opacity-30';

  return (
    <div className="flex flex-col items-center justify-between gap-3 px-4 py-3.5 sm:flex-row sm:px-5">
      <p className="tabular text-[13px] text-gray-500">
        Mostrando {from}–{to} de {total} {noun}
      </p>
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <button type="button" className={arrow} disabled={page === 1} onClick={() => onChange(page - 1)} aria-label="Página anterior">
            <ChevronLeft className="h-4 w-4" />
          </button>
          {pageList(page, totalPages).map((p) =>
            typeof p === 'string' ? (
              <span key={p} className="w-6 text-center text-sm text-gray-400">…</span>
            ) : (
              <button
                key={p}
                type="button"
                onClick={() => onChange(p)}
                className={`tabular h-8 min-w-[2rem] rounded-lg px-2 text-sm font-medium transition ${
                  p === page ? 'bg-accent text-white shadow-sm' : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {p}
              </button>
            )
          )}
          <button type="button" className={arrow} disabled={page === totalPages} onClick={() => onChange(page + 1)} aria-label="Próxima página">
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  );
};
